import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Selector, Label, NumericInput, Flex } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Model from "./NearbyAccumulator.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.map.NearbyAccumulatorEditor');
const values = [{
  get name() {
    return t('feet');
  },
  value: 'feet'
}, {
  get name() {
    return t('meters');
  },
  value: 'meters'
}, {
  get name() {
    return t('kilometers');
  },
  value: 'kilometers'
}, {
  get name() {
    return t('miles');
  },
  value: 'miles'
}];
export default function NearbyAccumulatorEditor(props) {
  const {
    value
  } = props;
  const onChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "center",
      children: [/*#__PURE__*/_jsx(Label, {
        children: t('units')
      }), /*#__PURE__*/_jsx(Selector, {
        eventData: "setUnits",
        onChange: onChange,
        value: Model.getUnits(value),
        values: values
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "center",
      children: [/*#__PURE__*/_jsx(Label, {
        children: t('clusteringDistance')
      }), /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setClusterDistance",
        onChange: onChange,
        value: Model.getClusterDistance(value)
      })]
    })]
  });
}